
import wareView from "../components/ware-view"
import breadcrumb from "../library/breadcrumb.vue"
import { getCategoryList } from "../api/gateway"
import getCartNumMixin from "@/mixins/getCartNum"
import { translate } from "@/plugins/i18n"
import commonConfig from "@/utils/common"
import { wareSearch } from "@/api/category.js"
import { genfilterAndSortParams } from "@/utils/category"
import { getHeadLink, getHeadMeta } from "@/utils/head"
import { getRequestHeaders } from "@/utils/utils"
import { Logger } from "@/plugins/logger"
function getCategoryFromSelect(selected, list = []) {
  const path = []
  for (const i in selected) {
    path.push(selected[i])
  }
  const level = path.length
  let curList = list
  let name = ""
  const pathName = []
  let isLeaf = false
  for (let i = 0; i < level; i++) {
    const item = curList.find(v => v.categoryId === path[i])
    if (item) {
      if (item.childCategoryList && item.childCategoryList.length) {
        curList = item.childCategoryList
      } else {
        isLeaf = true
      }
      name = item.categoryName
      pathName.push({ id: item.categoryId, name: item.categoryName })
    } else {
      return {
        path,
        isLeaf,
        name: "",
        pathName,
        childList: []
      }
    }
  }
  return {
    path,
    isLeaf,
    name,
    pathName,
    childList: curList
  }
}

export default {
  components: {
    wareView,
    breadcrumb
  },
  mixins: [getCartNumMixin],
  provide() {
    return {
      cascaderData: this.cascaderData
    }
  },
  validate({ query, params }) {
    return params.categoryId && params.page
  },
  props: {
    configs: {
      type: Object,
      default: () => {}
    }
  },
  async asyncData({ params, route, req, error, query, store }) {
    try {
      let productList = []
      let pageInfo = {}
      const { data } = await getCategoryList(
        {
          param: {
            selected: params.categoryId.split("-").join(","),
            pageSize: 10,
            page: query.page || params.page
          },
          comm: {}
        },
        {
          loading: true,
          headers: getRequestHeaders({ req, store })
        }
      )
      productList = data.productList
      pageInfo = data.pageInfo
      const category = getCategoryFromSelect(data.selected, data.categoryList)
      const commonParams = store.state.commonParams
      const commonReqParams = {
        businessCode: commonParams.businessCode,
        categoryType: 1,
        erpStoreId: commonParams.storeId,
        venderId: commonParams.venderId
      }
      const cateReqParams = {
        categoryId: category.path[category.path.length - 1],
        categoryLevel: category.path.length
      }
      const searchParam = {
        ...commonReqParams,
        ...cateReqParams,
        pageNum: query.page || params.page || 1,
        pageSize: 20,
        ...genfilterAndSortParams(query)
      }
      if (query.sortKey || query.proId) {
        try {
          const { data } = await wareSearch(
            {
              param: searchParam
            },
            {
              headers: getRequestHeaders({ req, store })
            }
          )
          productList = data?.wareList || []
          pageInfo = data?.pageInfo || {}
        } catch (error) {
          console.log(error, "err")
        }
      }
      const sel = []
      const pathName = category.pathName
      const path = category.path
      if (pathName.length) {
        for (let i = 0; i < pathName.length; i++) {
          pathName[i].path = i < 2 ? path.slice(0, i + 1).join(",") : null
          sel.push({
            name: pathName[i].name,
            // path: pathName[i].path
            params: pathName[i].path
          })
        }
      }
      const whereFrom = {
        name: translate("common.home"),
        path: "/"
      }
      const breadcrumbData = [whereFrom, ...sel]
      const fullPath = route.fullPath
      const lang = store.state.lang
      return {
        pageTitle: category?.name || "",
        category,
        defaultSelected: data.selected,
        productListDatas: productList,
        filterProperty: data.filterProperty,
        pageInfo,
        breadcrumbData,
        lang: lang == "en_US" ? "en" : "zh-hant",
        fullPath
      }
    } catch (err) {
      Logger.error("category初始化报错", err)
      error({
        statusCode: 500,
        message: "Internal Server Error"
      })
    }
  },
  data() {
    return {
      suspensionExpand: false,
      cascaderData: [],
      defaultSelected: [],
      productListDatas: [],
      filterProperty: [],
      category: {},
      breadcrumbData: [],
      keyword: "",
      fullPath: "",
      lang: "",
      pageTitle: ""
    }
  },
  head() {
    return {
      title: this.pageTitle,
      meta: [
        { name: "type", content: "website" },
        { hid: "description", name: "description", content: this.pageTitle },
        { name: "og:type", content: "website" },
        { name: "og:title", content: this.pageTitle },
        { name: "og:description", content: this.pageTitle },
        ...getHeadMeta(this)
      ],
      link: getHeadLink(this)
    }
  },
  mounted() {},
  methods: {
    sunpensionClick() {
      this.suspensionExpand = !this.suspensionExpand
    },
    // 分类页需要组装分类的面包屑, 第三级path设置为null
    initBreadcrumb() {
      const sel = []
      const pathName = this.category.pathName
      const path = this.category.path
      if (pathName.length) {
        for (let i = 0; i < pathName.length; i++) {
          pathName[i].path = i < 2 ? path.slice(0, i + 1).join(",") : null
          sel.push({
            name: pathName[i].name,
            // path: pathName[i].path
            params: pathName[i].path
          })
        }
      }
      const whereFrom = {
        name: this.$t("common.home"),
        path: this.MAIN_ORIGIN_HOME
      }

      this.breadcrumbData = [whereFrom, ...sel]
    }
  }
}
